import {memo, useEffect, useMemo, useState} from "react";
import {Button, Row, Col, Spin, Alert, Typography, Space, Tabs, Card, Divider} from "antd";
import SanKey from "../Charts/SanKey";
import useGroup from "../Data/Groups";
import { LoadingOutlined } from '@ant-design/icons';
import useSWR from "swr";
import axios from "axios";
import SubGroupSkillsSanKey from "../Charts/SubGroupSkillsSanKey";
import SkillsBarChart from "../Charts/SkillsBarChart";
import GrowthRateChart from "../Charts/GrowthRateChart";
import IndustryChart from "../Charts/IndustryChart";
import Group from "./Group";
import SubGroup from "./SubGroup";

const { TabPane } = Tabs;
const { Title } = Typography;

const MainGroup = memo(() => {

    const [currentPage, setCurrentPage] = useState("home");

    const { data: groups, error } = useSWR('/groups');

    const [selectedGroup, setSelectedGroup] = useState(null);

    const subGroupQuery = useMemo(() => `/groups/${selectedGroup?.id}`,
        [selectedGroup]);
    const { data: subGroups } = useSWR(selectedGroup ? subGroupQuery : null);
    // const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    useEffect(() => {
        if(groups && !selectedGroup) {
            setSelectedGroup(groups?.[0]);
        }
    }, [groups, selectedGroup, setSelectedGroup])

    if(error) {
        return <Row justify={'center'} style={{ marginTop: '24px' }}>
            <Col span={20}>
                <Alert
                    message="เกิดข้อผิดพลาด"
                    description={`ไม่สามารถดาวน์โหลดข้อมูลได้ กรุณาลองอีกครั้งภายหลัง : ${error}`}
                    type="error"
                    showIcon
                />
            </Col>
        </Row>
    }

    return <>
        {/*<Row justify={'center'}>*/}
        {/*    <Col>*/}
        {/*        <Title*/}
        {/*            style={{*/}
        {/*                borderBottom: 'solid 0.2rem var(--primary)'*/}
        {/*            }}*/}
        {/*        >*/}
        {/*            Skill Mapping*/}
        {/*        </Title>*/}
        {/*    </Col>*/}
        {/*</Row>*/}
        {!groups ?
            <Row justify={'center'} style={{ marginTop: '24px' }}>
                <Col>
                    <Spin indicator={<LoadingOutlined style={{ fontSize: 72 }} spin />} />
                </Col>
            </Row> :
            <>
                <Row justify={'center'}>
                    <Col>
                        <Space wrap>
                            { groups.map((group) => (
                                <Button
                                    type={group.id === selectedGroup?.id ? 'primary' : 'default'}
                                    size={'large'}
                                    onClick={() => {
                                        setSelectedGroup(group)
                                    }}
                                >
                                    {group?.name}
                                </Button>
                            )) }
                        </Space>
                    </Col>
                </Row>
                { !selectedGroup || !subGroups?.skills_overview.length ? <>
                        {
                            subGroups && !subGroups?.skills_overview.length ? <>
                                <Alert
                                    message="กำลังปรับปรุงข้อมูล"
                                    description="ข้อมูลชุดนี้อยู่ระหว่างการปรับปรุง กรุณาลองอีกครั้งภายหลัง"
                                    type="warning"
                                    showIcon
                                    style={{ marginTop: '24px' }}
                                />
                            </> : <>
                                <Row justify={'center'} style={{ marginTop: '24px' }}>
                                    <Col>
                                        <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
                                    </Col>
                                </Row>
                            </>
                        }
                    </> :
                    <>
                        { groups.map((group) => // map this to create multiple component not reuse same component
                            <>
                                {
                                    group.id === selectedGroup?.id && <>
                                        <Tabs tabPosition={window.innerWidth > 768 ? 'left' : 'top'}>
                                            <TabPane tab="ภาพรวม" key="overview">
                                                <Group selectedGroup={selectedGroup} />
                                            </TabPane>
                                            {subGroups?.sub_groups?.map((subGroup) => {
                                                return (
                                                    <TabPane tab={subGroup?.name} key={subGroup?.id}>
                                                        <SubGroup groupId={selectedGroup?.id} subGroupId={subGroup?.id} />
                                                    </TabPane>
                                                );
                                            })}
                                        </Tabs>
                                    </>
                                }
                            </>
                        ) }

                    </>
                }

            </>
        }
    </>
});

export default MainGroup;
